var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H60C65.5229 0 70 4.47715 70 10V66C70 71.5229 65.5229 76 60 76H10C4.47715 76 0 71.5229 0 66V10Z",
    fill: "#B6D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_1377)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_349_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.349 54H44.6523C45.8009 54 46.7572 53.1215 46.7572 52.0419V28.6286C46.7572 27.5487 45.8009 26.6609 44.6523 26.6609H41.4702V28.4487C41.4748 28.759 41.23 29.0158 40.92 29.0261H29.0436C28.7273 29.0185 28.4719 28.765 28.4615 28.4487V26.6609H25.349C24.2004 26.6609 23.2441 27.5487 23.2441 28.6286V52.0419C23.2441 53.1215 24.2004 54 25.349 54ZM29.6441 36.0522C29.6441 35.7449 29.8933 35.4957 30.2007 35.4957H33.0528V32.6435C33.0528 32.3362 33.302 32.087 33.6094 32.087H36.392C36.6993 32.087 36.9485 32.3362 36.9485 32.6435V35.4957H39.8007C40.108 35.4957 40.3572 35.7449 40.3572 36.0522V38.8348C40.3572 39.1421 40.108 39.3913 39.8007 39.3913H36.9485V42.2435C36.9485 42.5508 36.6993 42.8 36.392 42.8H33.6094C33.302 42.8 33.0528 42.5508 33.0528 42.2435V39.3913H30.2007C29.8933 39.3913 29.6441 39.1421 29.6441 38.8348V36.0522ZM29.8708 45.6522H40.1306C40.4382 45.6522 40.6871 45.9014 40.6871 46.2087C40.6871 46.5161 40.4382 46.7652 40.1306 46.7652H29.8708C29.5632 46.7652 29.3142 46.5161 29.3142 46.2087C29.3142 45.9014 29.5632 45.6522 29.8708 45.6522ZM27.7838 48.4348H42.2175C42.5251 48.4348 42.774 48.684 42.774 48.9913C42.774 49.2987 42.5251 49.5478 42.2175 49.5478H27.7838C27.4762 49.5478 27.2273 49.2987 27.2273 48.9913C27.2273 48.684 27.4762 48.4348 27.7838 48.4348Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3568 24.1565H37.7525C37.4905 24.1563 37.2639 23.9734 37.2087 23.7171C36.9935 22.7226 36.0489 22 34.9625 22H34.9557C33.8984 21.9989 32.9748 22.7144 32.7117 23.7383C32.6484 23.9842 32.4267 24.1563 32.1726 24.1565H29.5742V27.913H40.3568V24.1565Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1646 38.8347V41.6869H35.8341V38.8347C35.8341 38.5274 36.0833 38.2782 36.3906 38.2782H39.2428V36.6086H36.3906C36.0833 36.6086 35.8341 36.3595 35.8341 36.0521V33.2H34.1646V36.0521C34.1646 36.3595 33.9154 36.6086 33.608 36.6086H30.7559V38.2782H33.608C33.9154 38.2782 34.1646 38.5274 34.1646 38.8347Z",
    fill: "#0061FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_349_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(19 22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookNow);
export default __webpack_public_path__ + "static/media/book-now.976b18176866aeba31f6fe0c03f84653.svg";
export { ForwardRef as ReactComponent };